<!--
 * @Author: wxy
 * @Date: 2022-07-05 14:11:41
 * @LastEditTime: 2022-10-21 09:50:29
 * @Description: 政策通报详情
-->
<template>
  <div ref="box" style="overflow-y: scroll;" :style="{ height: height }">
    <div class="header">
      <ds-header title="通报政策查看" style="width: 100%"></ds-header>
      <a-button type="primary" @click="() => this.$router.go(-1)">返回</a-button>
    </div>
    <div class="content">
      <a-form-model ref="ruleForm" :model="form" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
        <a-form-model-item label="政策标题"> {{ form.policyTitle }} </a-form-model-item>
        <a-form-model-item label="政策简介"> {{ form.policyIntroduce || "暂无" }} </a-form-model-item>
        <a-form-model-item label="政策申报日期">
          <span v-if="form.policyStartTime"> {{ form.policyStartTime }} 至{{ form.policyEndTime }}</span
          ><span v-else>暂无</span></a-form-model-item
        >
        <a-form-model-item label="发文单位">
          <span v-if="form.documentUnit"> {{ form.documentUnit }}</span>
          <span v-else>暂无</span>
         </a-form-model-item>
        <a-form-model-item label="发文字号">
          <span v-if="form.documentNumber">{{form.documentNumber}}</span>
          <span v-else>暂无</span>
        </a-form-model-item>
        <a-form-model-item label="发文时间">
          <span v-if="form.documentTime">{{ form.documentTime }}</span>
          <span v-else>暂无</span>
        </a-form-model-item>
        <a-form-model-item label="有效期">
          <span v-if="form.documentPeriodValidityStart"> {{ form.documentPeriodValidityStart }} 至{{ form.documentPeriodValidityEnd }}</span>
          <span v-else>暂无</span>
        </a-form-model-item>
        <a-form-model-item label="政策内容配置">
          {{ form.policyFormat === 1 ? "自主编辑" : "第三方链接" }}
        </a-form-model-item>
        <a-form-model-item label="政策详情" v-if="form.policyFormat === 1">
          <div v-html="form.policyDetail"></div>
        </a-form-model-item>
        <a-form-model-item label="链接URL" v-if="form.policyFormat === 2"> {{ form.policyLink }} </a-form-model-item>
        <a-form-model-item label="是否展示标题栏" v-if="form.policyFormat === 2">
          {{ form.isShowTitle === 1 ? "是" : "否" }}
        </a-form-model-item>
        <a-form-model-item label="附件上传" v-if="form.policyFormat === 1">
          <div v-if="form.policyFileList.length">
            <div v-for="(item, index) in form.policyFileList" :key="index">
              <a :href="item.url" target="_blank">{{ item.name }}</a>
            </div>
          </div>
          <div v-else>暂无</div>
        </a-form-model-item>
        <div v-for="(item, index) in form.typeProjectList" :key="index">
          <a-form-model-item label="政策类型"> {{ item.policyTypeName || "暂无" }} </a-form-model-item>
          <a-form-model-item label="所属项目"> {{ item.projectName }} </a-form-model-item>
        </div>
        <a-form-model-item label="所属模块"> 
            <span v-for="(item,index) in form.moduleProjectList">
              {{ item.moduleName }} {{form.moduleProjectList.length-1==index?'':','  }}
            </span>
        </a-form-model-item>
        <!-- <a-form-model-item label="是否弹窗提醒"> {{ form.policyPopupShow }} </a-form-model-item>
        <a-form-model-item label="弹窗展示时间" v-if="form.policyPopup === 0">
          {{ form.popupStartTime }}至{{ form.popupEndTime }}
        </a-form-model-item> -->
        <a-form-model-item label="是否发布"> {{ form.policyPublishedStatusShow }} </a-form-model-item>
        <a-form-model-item label="政策创建人"> {{ form.createIdShow }} </a-form-model-item>
        <a-form-model-item label="政策创建时间"> {{ form.gmtCreate }} </a-form-model-item>
        <a-form-model-item label="政策最后修改人"> {{ form.modifiedIdShow || "暂无" }}</a-form-model-item>
        <a-form-model-item label="政策最后修改时间"> {{ form.gmtModified || "暂无" }} </a-form-model-item>
      </a-form-model>
    </div>
  </div>
</template>

<script>
import { policyReportDetail } from "@/api/entrepreneurClubManagement/policyManagement";
import { over } from "lodash";
export default {
  name: "policyReportDetail",
  data() {
    return {
      form: {
        // 附件上传列表
        policyFileList: [],
      },
      height:''
    };
  },
  mounted() {
    // 获取详情数据
    this.getDetail();
    this.height = window.innerHeight-160+'px'
  },
  methods: {
    // 获取详情数据
    async getDetail() {
      try {
        const policyId = this.$route.query.id;
        const res = await policyReportDetail(policyId);
        if (res.code === "200") {
          this.form = res.data;
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {}
    },
  },
};
</script>

<style lang='scss' scoped>
.header {
  display: flex;
  justify-content: space-between;
}
.content {
  width: 70%;
  margin: 10px auto;
}
::v-deep  table {
    border: none;
    border-collapse: collapse;
}
::v-deep  table td{
     border: 1px solid #ccc;
     padding: 3px 5px;
     min-width: 50px;
     height: 20px;
}
::v-deep  table th {
     border-right: 1px solid #ccc;
     border-bottom: 2px solid #ccc;
     text-align: center;
     background-color: #f1f1f1;
     border: 1px solid #ccc;
     padding: 3px 5px;
     min-width: 50px;
     height: 20px;
}
</style>